<p>
  {{
    'sharedModule.bkgVehicleDialogUmcSelectors.addMakeModelSubtitle' | translate
  }}
</p>

<form [formGroup]="umcDataForm" class="modal__section form-compact">
  <div class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.model' | translate }}
      <div
        *ngIf="loadingUmcData"
        class="blue-spinner__small loading__spinner"
      ></div>
    </label>
    <ng-select
      #selectModelDescriptionSelect
      (change)="selectModelDescriptionSelect.blur()"
      formControlName="modelDescriptionSelect"
      id="modelDescriptionSelect"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.selectModel' | translate
      }}"
      controlErrorsClass="info-field--warning"
      [appendTo]="'body'"
    >
      <ng-option
        *ngFor="let umc of umcSelectorValues"
        [value]="umc.modelDescription"
        >{{ umc.modelDescription }}</ng-option
      >
    </ng-select>
  </div>
  <div class="form-group">
    <label class="text-start">
      {{ 'sharedModule.bkgVehicleDialogUmcSelectors.propulsion' | translate }}
      <div
        *ngIf="loadingPropulsion"
        class="blue-spinner__small loading__spinner"
      ></div>
    </label>
    <ng-select
      #selectModelIdSelect
      (change)="selectModelIdSelect.blur()"
      formControlName="propulsionCodeSelect"
      id="propulsionCodeSelect"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'sharedModule.bkgVehicleDialogUmcSelectors.selectPropulsion' | translate
      }}"
      controlErrorsClass="info-field--warning"
      [appendTo]="'body'"
    >
      <ng-option *ngFor="let p of propulsions" [value]="p.propulsion_code">{{
        p.propulsion
      }}</ng-option>
    </ng-select>
  </div>
  <p>
    <a class="link" (click)="onClickNotFoundCarOption()">
      {{
        'sharedModule.bkgVehicleDialogUmcSelectors.notFoundCarOption'
          | translate
      }}</a
    >
  </p>

  <button
    class="btn-primary btn-large is-block"
    [class.disabled]="isButtonDisabled"
    (click)="sendUmcDataForm()"
  >
    {{ 'sharedModule.bkgVehicleDialogUmcSelectors.agree' | translate }}
  </button>
</form>
